import React, { useRef, useEffect } from 'react';

type SearchBoxProps = {
  onChange: (value: string) => void;
  placeholder?: string;
};

const SearchBox: React.FC<SearchBoxProps> = ({
  onChange,
  placeholder = 'Search',
}) => {
  const inputRef = useRef(null);

  const changeValue = value => onChange(value);

  useEffect(() => {
    if (inputRef.current) {
      // stop hotkeys from grabbing focus from text field
      inputRef.current.onkeydown = event => event.stopPropagation();
    }
    // This is necessary to get the input focused with aha-search-field. The 1ms
    // delay appears to be necessary for .focus() to work (previously was 0ms).
    // In at least one case, we mount this component after loading has occured,
    // so there may be an issue where the input is initialized/mounted but not firable.
    setTimeout(() => inputRef.current?.focus(), 1);
  }, []);

  return (
    <aha-search-field
      // @ts-ignore not sure how to pass a ref to WC yet
      ref={inputRef}
      placeholder={placeholder}
      style={{
        width: '100%',
        margin: '5px 0',
        fontSize: '13px',
        fontWeight: '400',
      }}
      onInput={event => changeValue(event.target.value)}
    />
  );
};

export default SearchBox;
